/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.effacement.ts
 *
 * Messages du cycle « révoquer, archiver, supprimer définitivement » d'un
 * compte participant (page Comptes inscrits, 2026-10-01). Fusionné dans
 * fr.ts. Aucun tiret cadratin, le mot du module d'activités vient du
 * lexique de l'événement.
 *
 * Mikael - chef de projet - 2026-10-01
 */
export const messagesEffacementFr: Record<string, string> = {
  // ── Archiver / rétablir (page Comptes inscrits) ──────────────────────
  'usersList.btn.archive': 'Archiver',
  'usersList.confirm.archive':
    'Archiver le compte de {name} ? Il ne comptera plus dans aucune statistique, aucun export ni aucune relance. Vous pourrez le rétablir.',
  'usersList.toast.archived': 'Compte archivé : il ne compte plus dans les chiffres.',
  'usersList.toast.archiveRequiresRevoked': 'Révoquez d’abord l’accès de ce compte, puis archivez-le.',
  'usersList.btn.erase': 'Supprimer définitivement',
  'usersList.btn.eraseAria': 'Supprimer définitivement le compte de {name}',
  'usersList.cycle':
    'Cycle d’un compte de test ou d’un doublon : révoquer l’accès, archiver (il ne compte plus nulle part), puis supprimer définitivement.',

  // ── Fenêtre de suppression définitive ────────────────────────────────
  'effacement.titre': 'Supprimer définitivement {name}',
  'effacement.chargement': 'Calcul de ce qui sera supprimé…',
  'effacement.erreur': 'Impossible de préparer la suppression.',
  'effacement.intro':
    'Tout ce qui concerne ce compte sera supprimé, sans retour possible. Il ne comptera plus dans aucun chiffre, aucun export, aucune relance.',
  'effacement.categories': 'Ce qui sera supprimé',
  'effacement.cat.compte': 'Le compte et ses rôles',
  'effacement.cat.fiche': 'La fiche exposant (et son option premium)',
  'effacement.cat.postes': 'Les offres d’emploi et les profils recherchés',
  'effacement.cat.recruteurs': 'Les recruteurs et les demandes de rattachement',
  'effacement.cat.scans': 'Les passages sur les stands (scans faits et reçus), les étoiles et les contrôles',
  'effacement.cat.cv': 'Les CV, leur analyse et leurs consultations',
  'effacement.cat.candidatures': 'Les candidatures',
  'effacement.cat.entretiens': 'Les entretiens, leurs notes et évaluations',
  'effacement.cat.ateliers': 'Les inscriptions aux {lexWorkshopPlural}, l’animation de {lexWorkshopPlural} et les programmes',
  'effacement.cat.connexion': 'Les codes de connexion, la double authentification et les notifications',
  'effacement.cat.donnees': 'Consentements, favoris, questionnaires, navigation, groupes et transport',
  'effacement.cat.journaux': 'Journaux de relance, campagnes, alertes et demande de code',
  'effacement.cat.audit': 'Les lignes du journal d’audit qui le concernent',
  'effacement.cat.liens': 'Liens rompus vers d’autres comptes ou objets (eux sont conservés)',
  'effacement.lignes': '{n, plural, one {# ligne} other {# lignes}}',
  'effacement.fichiers':
    '{n, plural, =0 {Aucun fichier sur le serveur} one {# fichier sur le serveur (CV, photo ou logo)} other {# fichiers sur le serveur (CV, photo, logo)}}',
  'effacement.total': '{n, plural, one {# ligne en tout} other {# lignes en tout}}',
  'effacement.emportes':
    'Comptes recruteurs de l’entreprise supprimés avec elle : {liste}',
  'effacement.inactifs':
    'Recruteurs désactivés de cette entreprise, conservés (à supprimer séparément) : {liste}',
  'effacement.preuve':
    'Une seule trace restera, sans aucune donnée personnelle : « compte #{id} supprimé par un super administrateur, nombre de lignes et de fichiers ». Elle prouve que la suppression a eu lieu.',
  'effacement.confirmer.label': 'Pour confirmer, tapez exactement : {phrase}',
  'effacement.confirmer.placeholder': 'Tapez la phrase ci-dessus',
  'effacement.bouton': 'Supprimer définitivement',
  'effacement.annuler': 'Annuler',
  'effacement.fermer': 'Fermer',
  'effacement.refus.titre': 'Suppression impossible pour l’instant',
  'effacement.cascade.liste': 'Recruteurs actifs de cette entreprise : {liste}',
  'effacement.cascade.case': 'Supprimer aussi ces comptes recruteurs (suppression en cascade)',
  'effacement.succes':
    '{name} a été supprimé définitivement ({lignes, plural, one {# ligne} other {# lignes}}, {fichiers, plural, one {# fichier} other {# fichiers}}).',
  'effacement.echec': 'La suppression a échoué : rien n’a été supprimé.',
};
